import React from 'react';
import PreferenceRow from './../PreferenceRow';

const RequestItem = (props) => (
  <PreferenceRow
    readOnly={props.readOnly}
    prefIndex={props.index}
    score={props.preference.score}
    scoreApplicable={props.preference.scoreApplicable}
    description={props.preference.description}
    totalEntries={props.totalEntries}
    bidId={props.preference.bidAggregateId}
    employeeBidId={props.preference.employeeBidId}
    handleDeletePreference={props.handleDeletePreference}
    handleDeleteCombinedPreference={props.handleDeleteCombinedPreference}
    handleNext={props.handleNext}
    bidSession={props.bidSession}
    handleMovePreference={props.handleMovePreference}
    handleWeightEdit={props.handleWeightEdit}
    optionLevel={props.preference.optionLevel}
    displayName={props.displayName}
    groupName={props.groupName}
    isCombined={props.isCombined}
    copyPreference={props.copyPreference}
  />
);

export default RequestItem;
